import BaseService from "./base.service";
const service = new BaseService("/equipment_configs/:id/equipment_divalto_codes")
export default service;
